import styled from 'styled-components';
import { Slider, Popover, Button, InputNumber, Radio, Icon } from 'antd';

export const EditorMenu = styled.div`
  flex-shrink: 0;
  width: 100%;
  height: 70px;
  background: rgb(37, 41, 45) !important;
  padding: 4px 8px;
  z-index: 3001;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const EditorContextToolbar = styled.div``;

export const EditorSettings = styled.div`
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  padding: 0px 5px 0px 20px;
  .switch-name {
    color: #fff;
    margin-left: 10px;
    margin-right: 10px;
  }
  .ant-btn {
    background: #b1272c !important;
    padding: 0px 8px !important;
    line-height: 0 !important;
    color: #fff !important;
    font-size: 15px !important;
    border: none !important;
    box-shadow: none !important;
    height: 30px;
    border-radius: 10px;
    margin: 5px;
  }
`;

export const EditAreaToolbarContainer = styled.div`
  position: relative !important;
  margin-left: ${props => props.isFillableElement && '-10px !important'};
  display: flex;
  align-items: center;
  z-index: 3;
  background-color: rgb(37, 41, 45);
  border-radius: 10px;
  .ql-toolbar.ql-snow {
    button {
      svg {
        position: absolute;
        color: #fff;
      }
    }
    border: initial;
    padding: 10px;
    .ql-formats {
      margin-right: 10px;
    }
  }
  .ql-snow {
    .ql-picker-label {
      color: #0e1318;
      font-weight: 600;
      border: 1px solid rgba(57, 76, 96, 0.15) !important;
      border-radius: 2px;
    }
    input {
      color: rgba(0, 0, 0, 0.65) !important;
    }
  }
  .ql-snow .ql-picker.ql-size {
    width: 68px;
    height: 32px;
    .ql-picker-label {
      display: flex;
      align-items: center;
      &.ql-active {
        color: #0e1318;
        svg {
          .ql-stroke {
            stroke: #fff;
          }
        }
      }
    }
  }
  .ql-picker-label[data-label]:not([data-label=''])::before {
    content: attr(data-label);
  }

  .ql-picker-item[data-label]:not([data-label=''])::before {
    content: attr(data-label);
  }

  .ql-snow .ql-picker.ql-lineheight,
  .ql-snow .ql-picker.ql-letterspace {
    min-width: 68px;
    width: auto;
    border: 1px solid rgba(57, 76, 96, 0.15) !important;
    height: 32px;
    .ql-picker-label {
      padding-right: 20px;
      display: flex;
      align-items: center;
      &.ql-active {
        color: #0e1318;
        svg {
          .ql-stroke {
            stroke: #fff;
          }
        }
      }
    }
    .ql-picker-options {
      text-align: center;
    }
  }
  .ql-snow .ql-stroke {
    fill: none;
    stroke: #fff !important;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 2;
  }
  #bullet-ref .ql-stroke,
  #spacing-ref .ql-stroke {
    stroke: #444 !important;
  }
  #spacing-ref,
  #spacing-ref .ql-picker-label {
    color: rgba(0, 0, 0, 0.65);
  }
  .ql-snow .ql-picker.ql-font {
    min-width: 130px;
    width: auto;
    height: 32px;
    .ql-picker-label {
      padding-right: 20px;
      display: flex;
      align-items: center;
      &.ql-active {
        color: #0e1318;
        svg {
          .ql-stroke {
            stroke: #fff;
          }
        }
      }
    }
  }
  #toolbar-fontsize {
    .ql-size {
      width: 80px;
      .ql-picker-label {
        padding-right: 20px;
      }
    }
  }
  .ql-custom-tray {
    svg {
      width: 22px !important;
      height: 22px !important;
    }
    .ql-picker {
      width: initial !important;
      height: 100% !important;
      margin: 0px 4px;
    }
    .custom-picker {
      margin: 0px 4px;
    }
    .ql-picker-label,
    .custom-picker {
      width: 28px;
      height: 32px;
      padding: 0px 3px;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      border: 1px solid transparent !important;
      &.ql-active {
        background-color: ${props => props.shortMsg ? 'rgba(255,255,255,0.2) !important' : 'rgba(14, 19, 24, 0.07) !important'};
        svg {
          .ql-stroke {
            stroke: #fff;
          }
        }
      }
    }
  }
  .ql-picker-options {
    max-height: 225px;
    overflow-y: auto;
    padding-top: 40px;
  }
  .ql-formats button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
  }

  .size-ref {
    width: 40px;
    height: 32px;
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    border-color: #d9d9d9;
    color: #fff;
    border-style: solid;
    border-top-width: 1px;
    border-bottom-width: 1px;
    white-space: nowrap;

    br {
      display: none;
    }

    * {
      display: inline;
      white-space: nowrap;
    }

    &:focus {
      overflow-x: auto;
    }
  }
  .ant-select {
    width: 200px !important;
  }
`;

export const SvgContextToolbar = styled.div`
  display: flex;
  flex-direction: row;
  border: none;
`;

export const ColorButton = styled(Button)`
  padding: 0 !important;
  height: 24px !important;
  width: 24px !important;
  border-radius: 2px;
  border: 0.5px solid #fff;
  background: ${props =>
    props.isComboText
      ? '#fff'
      : props.borderColor
      ? props.borderColor
      : 'rgb(204, 204, 204)'};
  margin: 0 4px;
  box-shadow: inset 0 0 0 1px rgba(14, 19, 24, 0.15);
  &:hover {
    border-color: ${props => (props.borderColor ? props.borderColor : 'rgb(204, 204, 204)')};
  }
  .ant-btn:hover,
  .ant-btn:focus {
    border-color: ${props => (props.borderColor ? props.borderColor : 'rgb(204, 204, 204)')};
  }
  p {
    color: ${props => props.isComboText && props.borderColor};    
    font-size: ${props => props.isComboText && '16px !important'};
    font-weight: ${props => props.isComboText && '700'};
  }
`;

export const LineStylePopover = styled(Popover)`
  width: 300px;
  .ant-popover {
    width: 300px;
  }
`;
export const LineWeightSlider = styled(Slider)`
  width: 100px;
  margin: 10px 0px 10px 16px !important;
`;
export const LineWeightLabel = styled.label`
  display: flex;
  align-items: center;
  justify-content: center;
  p {
    font-size: 12px;
  }
`;
export const LineWeightSliderWrapper = styled.div`
  padding: 16px;
  margin: 0px;
  display: flex;
`;

export const LineWeightInput = styled(InputNumber)`
  font-size: 12px !important;
  line-height: 1 !important;
  height: 24px !important;
  width: 40px !important;
  .ant-input-number-handler-wrap {
    display: none;
  }
  .ant-input-number-input {
    height: 22px;
    padding: 0px;
  }
  input {
    font-size: 12px;
    text-align: center;
  }
`;

export const LineWeightButton = styled(Button)`
  padding: 0 !important;
  height: 24px !important;
  width: 24px !important;
  border-radius: 2px;
  border: none;
  margin: 0 4px;
`;

export const BorderButton = styled(Button)`
  padding: 0 !important;
  height: 24px !important;
  width: 24px !important;
  border-radius: 2px;
  border: none;
  margin: 0 4px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const LineStyleButton = styled(Button)`
  padding: 0 !important;
  height: 24px !important;
  width: 24px !important;
  border-radius: 2px;
  border: none;
  margin: 0 4px;
`;

export const LineStyleGroup = styled(Radio.Group)`
  display: grid !important;
  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):focus-within {
    border-radius: 4px;
    background: rgba(64, 87, 109, 0.07);
    outline: 1px;
  }
  .ant-radio-button-wrapper {
    border: 0px !important;
    box-shadow: none !important;
  }
  .ant-radio-button-wrapper::before {
    background: none !important;
    box-shadow: none !important;
  }
  i.anticon.anticon-check {
    display: none;
  }
  .ant-radio-button-wrapper-checked i.anticon-check {
    display: block;
  }
`;

export const LineStyleButtonsWrapper = styled.div`
  margin: 0px;
  padding: 8px;
  ul {
    margin: 0;
    padding: 8px 0;
    list-style: none;
    width: 100%;
  }
  button {
    padding: 0 8px;
  }
`;

export const LineStyleOption = styled(Radio.Button)`
  .svg-lines {
    display: block;
    width: 100%;
    margin: 0 8px;
    max-width: 64px;
    max-height: 40px;
  }
`;

export const LineStyleOptionWrapper = styled.span`
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: space-between;
`;
export const CheckIcon = styled(Icon)`
  color: #000;
`;

export const ButtonSeparator = styled.div`
  background: rgba(57, 76, 96, 0.15);
  width: 1px;
  height: 24px;
  margin: 0px 2px 0px 5px;
`;

export const PickerContainer = styled.div`
  position: absolute;
  top: 4rem;
  left: 0.7rem;
`;
export const QlPickerContainer = styled.div`
  position: relative;
  top: 9.16rem;
  left: 6rem;
  z-index: 4000;
  svg {
    position: relative !important;
    top: -10px;
    left: 13px;
  }
`;

export const ElementBackgroundColor = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  color: #fff;
  border-radius: 10px;
  background-color: ${props => !props.version && '#b1272c'};
  fill: ${props => props.version && '#fff'};
  width: ${props => props.version && '45px'};
  margin-right: ${props => props.version && '5px'};
  margin-left: ${props => props.version && '10px'};
  box-shadow: ${props => !props.version && 'inset 0 0 0 1px rgba(57, 76, 96, 0.15)'};
  &:hover {
    cursor: pointer;
  }
  .anticon.anticon-down,
  .anticon.anticon-up {
    font-size: 15px;
    margin-left: 5px;
  }
`;

export const ElementBackgroundPicker = styled.div`
  position: absolute;
  right: 0px;
  top: 35px;
  z-index: 10000;
`;

export const FontSpan = styled.span`
  .ql-picker-options {
    width: 220px !important;
  }
`;

export const SizeContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  height: 350px;
  width: 130px;
  li {
    cursor: pointer;
    padding: 7px 20px;
    &:hover,
    &:focus {
      background-color: rgba(14, 19, 24, 0.07) !important;
    }
  }
`;

export const ButtonGroup = styled(Button.Group)`
  display: flex !important;
  margin-left: ${props => props.comboBox && '20px'};
  margin-right: ${props => props.comboBox && '20px'};
`;
export const SizeButton = styled(Button)`
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  width: ${props => (props.width ? props.width + 'px !important' : `auto !important`)};
  border: 1px solid #d9d9d9 !important;
  height: 32px !important;
  background: ${props => props.comboBox && 'rgb(37, 41, 45) !important'};
  padding: 0 10px !important;
  margin-right: ${props => (props.comboBox && !props.isMinus && '15px')};
  z-index: 10;
  &:hover {
    background-color: rgb(37, 41, 45) !important;
  }
  i {
    padding-right: ${props => (props.comboBox ? '0' : '12px')};
    margin-top: ${props => (props.comboBox ? '0' : '-29px')};
    color: #fff;
  }
  input {
    width: 50px;
    height: 99%;
    text-align: center;
    border-radius: unset;
    border-color: transparent;
    margin: 0px -15px;
    z-index: 100;
  }
  span {
    width: 170px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #fff;
  }
`;

export const GroupView = styled.div`
  padding: 12px 16px;
  z-index: 1;
  border-radius: 4px;
  width: 20rem;
  background: white;
  border: 1px solid lightgray;
  position: absolute;
  top: 41px;
  left: -6rem;
  box-shadow: rgb(0 0 0 / 15%) 0px 2px 8px;
  .ql-picker-label {
    width: 80px !important;
    background-color: 'rgba(57, 76, 96, 0.15)';
  }
`;

export const CustomButton = styled.button`
  display: flex;
  color: #000;
`;

export const VersionSection = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-evenly;
  margin-right: 20px;
  position: absolute;
  right: 20px;
  border-radius: 20px;
  transition: all 0.4s ease-in;
  transform: translate(50px, 50px);
  opacity: 0;
  z-index: 1;
  pointer-events: none;

  &.show {
    transform: translate(50px, 100px);
    opacity: 1;
    pointer-events: all;
  }

  .option {
    min-width: 80px;
    height: 30px;
    color: white;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    &:hover {
      cursor: pointer;
    }
  }
  button.ant-btn {
    background: #b1272c;
    border: 2px solid #b1272c;
    color: #fff;
    border-radius: 20px;
    text-transform: uppercase;
    font-size: 12px;
  }
  .versionSvg {
    position: absolute;
    right: ${props => (props.isEmail ? '40px' : '10px')};
    top: 10px;
    svg {
      width: 35px;
      height: 35px;
      box-shadow: rgb(60 64 67 / 30%) 0px 1px 1px 0px, rgb(60 64 67 / 15%) 0px 1px 3px 1px;
      border-radius: 24px;
      padding: 5px;
      padding-right: 3px;
      fill: #fff;
      background: #25292d;
    }
    i.version.anticon {
      padding: 3px;
      background: #25292d;
      border-radius: 24px;
    }
  }
  .testingSvg {
    position: absolute;
    right: ${props => (props.isEmail ? '40px' : '10px')};
    top: 90px;
    svg {
      width: 23px;
      height: 23px;
    }
    svg.anticon-spin {
      color: #fff;
      width: 40px;
      height: 40px;
      padding: 10px !important;
    }
    i.anticon.anticon-loading {
      box-shadow: rgb(60 64 67 / 30%) 0px 1px 1px 0px, rgb(60 64 67 / 15%) 0px 1px 3px 1px;
      border-radius: 24px;
      padding: 0px;
      background: #25292d;
    }
    i.anticon.testIcon {
      box-shadow: rgb(60 64 67 / 30%) 0px 1px 1px 0px, rgb(60 64 67 / 15%) 0px 1px 3px 1px;
      border-radius: 24px;
      padding: 8px;
      background: #25292d;
      fill: #fff;
    }
  }
  p {
    line-height: 1.5;
    font-size: 10px;
    color: #8a8a8a;
    font-weight: 200;
    letter-spacing: 0.5px;
    margin-top: 6px !important;
    text-transform: uppercase;
    text-align: center;
    @media only screen and (max-width: 1440px) {
      font-size: 8px;
    }
  }
`;

export const ToolbarContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 10px;
  font-size: 14px;

  > label {
    width: 30px;
  }
  > .ant-input-affix-wrapper {
    width: 85px;
    .ant-input-suffix {
      right: 10px;
    }
    input[type='number']::-webkit-inner-spin-button,
    input[type='number']::-webkit-outer-spin-button {
      opacity: 1;
    }
    .ant-input:not(:last-child) {
      padding-right: 32px;
    }
  }
`;
